import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  emailStored: null,
  appStatus: null,
  contactStored: null,
  gstn: null,
  gstname: null,
  checkoboxCheck: "",
  token: null,
};

const emailSlice = createSlice({
  name: "EmailData",
  initialState: initialState,
  reducers: {
    emailAction: (state, action) => {
      if (state.emailStored === action.payload) return;
      state.emailStored = action.payload;
    },
    appAction: (state, action) => {
      if (state.appStatus === action.payload) return;
      state.appStatus = action.payload;
    },
    contactAction: (state, action) => {
      if (state.contactStored === action.payload) return;
      state.contactStored = action.payload;
    },
    gstnAction: (state, action) => {
      if (state.gstn === action.payload) return;
      state.gstn = action.payload;
    },
    gstnameAction: (state, action) => {
      if (state.gstname === action.payload) return;
      state.gstname = action.payload;
    },
    checkBoxAction: (state, action) => {
      if (state.checkoboxCheck === action.payload) return;
      state.checkoboxCheck = action.payload;
    },
    tokenAction: (state, action) => {
      if (state.token === action.payload) return;
      state.token = action.payload;
    },
  },
});

export const {
  emailAction,
  appAction,
  contactAction,
  gstnAction,
  gstnameAction,
  checkBoxAction,
  tokenAction,
} = emailSlice.actions;
// export const resetState = () => ({
//   type: "mySlice/resetState",
// });
export const EmailReducer = emailSlice.reducer;
